"use client";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useMemo } from "react";
import { Box, useMultiStyleConfig } from "@chakra-ui/react";
import { Chart as ChartJS, BarElement, CategoryScale, LinearScale, Tooltip, } from "chart.js";
import { Bar } from "react-chartjs-2";
import { theme } from "@pluxee-design-system/core";
import { generateAxisTitle, generateTicks, customTooltip } from "./helpers";
ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip);
ChartJS.defaults.font = Object.assign(Object.assign({}, ChartJS.defaults.font), { family: theme.fonts.core.default });
const BarChart = ({ data: inputData, legend, xTitle, yTitle, dataLabelPrefix = "", dataLabelSuffix = "", yScaleMin: min, yScaleMax: max, stepSize, dataLabel, color = theme.colors.semantic.brand.primary, }) => {
    const styles = useMultiStyleConfig("BarChart");
    const tooltipRef = useRef(null);
    const data = useMemo(() => ({
        datasets: [
            {
                data: inputData,
                backgroundColor: color,
                hoverBackgroundColor: color,
                barThickness: 16,
            },
        ],
    }), [inputData, color]);
    const options = useMemo(() => ({
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            x: {
                grid: {
                    display: false,
                },
                title: generateAxisTitle(xTitle),
                ticks: Object.assign(Object.assign({}, generateTicks()), { maxRotation: 0, minRotation: 0 }),
            },
            y: Object.assign(Object.assign({ grid: {
                    display: true,
                }, border: {
                    display: false,
                }, title: generateAxisTitle(yTitle), ticks: Object.assign(Object.assign(Object.assign({}, generateTicks()), (stepSize ? { stepSize } : {})), { padding: 8 }) }, (min ? { min } : {})), (max ? { max } : {})),
        },
        plugins: {
            tooltip: {
                // Opt-out from the default tooltip
                enabled: false,
                // Customize the tooltip entirely
                external: (context) => dataLabel
                    ? customTooltip({
                        chart: context.chart,
                        tooltip: context.tooltip,
                        tooltipEl: tooltipRef.current,
                        dataLabelPrefix,
                        dataLabelSuffix,
                    })
                    : null,
            },
        },
    }), [
        stepSize,
        yTitle,
        xTitle,
        min,
        max,
        dataLabel,
        dataLabelPrefix,
        dataLabelSuffix,
    ]);
    return (_jsxs(Box, Object.assign({ sx: styles.container }, { children: [_jsx(Box, Object.assign({ sx: styles.chart }, { children: _jsx(Bar, { data: data, options: options }) })), legend ? _jsx(Box, Object.assign({ sx: styles.legend }, { children: legend })) : null, dataLabel ? _jsx(Box, { ref: tooltipRef, sx: styles.tooltip }) : null] })));
};
export default BarChart;
//# sourceMappingURL=BarChart.js.map